import { render, staticRenderFns } from "./AddFamilyMemberDialog.vue?vue&type=template&id=551611bc&scoped=true"
import script from "./AddFamilyMemberDialog.ts?vue&type=script&lang=ts&external"
export * from "./AddFamilyMemberDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./AddFamilyMemberDialog.scss?vue&type=style&index=0&id=551611bc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551611bc",
  null
  
)

export default component.exports